export var OrganizationUserStatus;
(function (OrganizationUserStatus) {
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_UNCONFIRMED"] = "UNCONFIRMED";
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_CONFIRMED"] = "CONFIRMED";
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_ARCHIVED"] = "ARCHIVED";
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_COMPROMISED"] = "COMPROMISED";
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_UNKNOWN"] = "UNKNOWN";
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_RESET_REQUIRED"] = "RESET_REQUIRED";
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_FORCE_CHANGE_PASSWORD"] = "FORCE_CHANGE_PASSWORD";
    OrganizationUserStatus["ORGANIZATION_USER_STATUS_EXTERNAL_PROVIDER"] = "EXTERNAL_PROVIDER";
})(OrganizationUserStatus || (OrganizationUserStatus = {}));
